import { gql } from 'graphql-tag'

// TODO is this missing moduleMedia import?
export default gql`
  {
    sys {
      id
    }
    title
    date
    pressCategory
    city {
      sys {
        id
      }
      name
      country {
        region {
          sys {
            id
          }
          name
        }
      }
    }
    image {
      ...ModuleMediaFragment
    }
  }
`
